import AccountPassword from './account-password';
export default AccountPassword;
